module.exports = __webpack_public_path__ + "images/emoji/star2.426b199dacf154ef4741.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/star2.png
// module id = 8bEJ
// module chunks = 1